import { Link } from "react-router-dom";
import { dramas } from "@/mocks/dramas";

const latestDramas = dramas.slice(0, 8);

export default function LatestUpdates() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-1">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">
              实时更新剧集资源，追剧不错过
            </p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            {["全部", "悬疑", "古装", "都市"].map((tab, idx) => (
              <button
                key={tab}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  idx === 0
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-5">
          {latestDramas.map((drama) => (
            <Link
              key={drama.id}
              to={`/article/${drama.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-xl mb-3 aspect-[3/4]">
                <img
                  src={drama.coverImage}
                  alt={drama.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    <i className="ri-play-fill text-sm"></i>
                    立即观看
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-black/60 text-background-50 backdrop-blur-sm whitespace-nowrap">
                    {drama.rating}
                  </span>
                </div>
                {drama.featured && (
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                      热播
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading truncate group-hover:text-primary-600 transition-colors duration-200">
                {drama.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">
                {drama.category} · {drama.updateInfo}
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/remen"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-300 text-foreground-600 text-sm font-medium hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览全部剧集
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}